
import { CoatingsComponentWidget } from "./CoatingsComponentWidget";
import { CoatingsComponentController } from "../CoatingsComponentController";
import { Coating, Floor, FloorCoatingArea, roomManager } from "@rhinov/savane-js";
export class FloorCoatingAreaComponentWidget extends CoatingsComponentWidget {

    areaController: CoatingsComponentController;
    areaEvents: Array<{id: string, event: string, handler: (event: Event) => void, param: string, set: {id: string, value: any}}>;
    floorCoatingArea: FloorCoatingArea;


    setCheckBox(event: MouseEvent) {
        this.areaController.getUpdateFGProperty((event.currentTarget as HTMLInputElement & { param?: string }).param!, this.floorCoatingArea, (event.currentTarget as HTMLInputElement).checked);
    }

    setValue(event: Event) {
        var inputElement = event.currentTarget as HTMLInputElement
        if (inputElement.value === ""){
            inputElement.value = "0";
        }
        this.areaController.getUpdateProperty((event.currentTarget as HTMLInputElement & { param?: string }).param!, this.floorCoatingArea, Number(inputElement.value));
        this.areaController.floorUpdated();
    }

    constructor (component: FloorCoatingArea, index: number) {
        super(component, index);
        this.areaController = new CoatingsComponentController(component);
        this.floorCoatingArea = component as FloorCoatingArea;
        this.areaEvents = [
            {id:"altitudeComponent-", event: "input", handler: (e: Event) => this.setValue(e), param: "altitude", set: {id: 'value', value: this.floorCoatingArea.altitude / 10}},
            {id:"hangtype-", event: "change", handler: (e: Event) => { this.setValue(e); this.changeAltitudeForHangType(e as MouseEvent); }, param: "hangType", set: {id: 'value', value: this.floorCoatingArea.hangType}},
        ]
        if (this.floorCoatingArea.floorGeneratorSettings) {
            this.areaEvents.push({id:"cutButton-", event: "change", handler: (e: Event) => this.setCheckBox(e as MouseEvent), param: "cut", set: {id: 'checked', value: this.floorCoatingArea.floorGeneratorSettings.cut}});
        }
    }

    changeAltitudeForHangType(e: MouseEvent) {
        let newAltitude;

        switch(this.floorCoatingArea.hangType) {
            case Coating.HangType.floor:
                newAltitude = -99999999;
                for (let i = 0 ; i < this.floorCoatingArea.vertices.length ; i++) {
                    let room = roomManager.getRoomAtPosition(this.floorCoatingArea.vertices[i], this.floorCoatingArea.entity as Floor);
                    if (room) {
                        if (room.floorHeight > newAltitude) {
                            newAltitude = room.floorHeight;
                        }
                    }
                }
                this.floorCoatingArea.altitude = newAltitude;
                break;

            case Coating.HangType.ceiling:
                newAltitude = 99999999;
                for (let i = 0 ; i < this.floorCoatingArea.vertices.length ; i++) {
                    let room = roomManager.getRoomAtPosition(this.floorCoatingArea.vertices[i], this.floorCoatingArea.entity as Floor);
                    if (room) {
                        if (room.height < newAltitude) {
                            newAltitude = room.height;
                        }
                    }
                }
                this.floorCoatingArea.altitude = newAltitude;
                break;
        }

        let element = document.getElementById('altitudeComponent-' + this.index) as HTMLInputElement;
        element['value'] = "" + this.floorCoatingArea.altitude / 10;
    }

    override setCoatingsListener () {
        super.setCoatingsListener();
        this.areaEvents.forEach(({id, event, handler, param, set}) => {
            let element = document.getElementById(id + this.index) as HTMLInputElement & { param?: string };
            if (!element) return;
            if (param) {
                element.param = param;
            }
            if (set){
                (element as any)[set.id] = set.value;
            }
            element.addEventListener(event, handler.bind(this));
        })
    }

    override setPropertyComponentFG(event: Event) {
        super.setPropertyComponentFG(event);
        if ((event.currentTarget as HTMLInputElement & { param?: string }).param === "bevelValue") {
            let cleat = document.getElementById(`cleatCoating_${this.index}`);
            if (cleat) {
                switch (this.floorCoatingArea.floorGeneratorSettings.bevelValue) {
                    case undefined:
                    case 0:
                        cleat.style.display = 'block';
                        break;
                    default:
                        cleat.style.display = 'none';
                        break;
                }
            }
        }
    }

    override destroyCoatingsListener() {
        super.destroyCoatingsListener();
        this.areaEvents.forEach(({id, event, handler}) => {
            let element = document.getElementById(id + this.index);
            if (!element) return;
            
            element.removeEventListener(event, handler);
        })
    }

    endFloorgenerator(): string {

        var html = "";
        if (this.floorCoatingArea.floorGeneratorSettings.pattern !== 'basket') {
            html += `
                <div class="togglebutton" style="padding-right:16px">
                    <label class="horizontal-toggle">
                        <div style="padding-right: 10px">Découpe</div>
                        <input id="cutButton-${this.index}" type="checkbox">
                        <span class="toggle"></span>
                    </label>
                </div>
            `;
        }

        html += `
            <div class="togglebutton">
                <div class="input-wrapper">
                    <h5>Altitude:</h5>
                    <input id="altitudeComponent-${this.index}" onClick="this.select();" class="inputEnterValited form-control"
                        type="number" style="width:40px;padding:4px;margin-left:4px">
                    <h5>cm</h5>
                </div>
                <div>
                    <h5>Position:</h5>
                    <div>
                        <select id="hangtype-${this.index}" class="inputEnterValited form-control" style="padding:4px;margin-left:4px">
                            <option value="0">Sol</option>
                            <option value="1">Plafond</option>
                        </select>
                    </div>
                </div>
            </div>
        `;

        return html + `
            </div>
        `;
    }

    noFloorGeneratorHtml(): string{
        var html = "";
        html += super.noFloorGeneratorHtml();
        html += `
            <div class="togglebutton" style="width: 25%;padding-bottom: 5px">
                <div class="input-wrapper">
                    <h5>Altitude:</h5>
                    <input id="altitudeComponent-${this.index}" onClick="this.select();" class="inputEnterValited form-control"
                        type="number" style="width:40px;padding:4px;margin-left:4px">
                    <h5>cm</h5>
                </div>
                <div>
                    <h5>Position:</h5>
                    <div>
                        <select id="hangtype-${this.index}" class="inputEnterValited form-control" style="padding:4px;margin-left:4px">
                            <option value="0">Sol</option>
                            <option value="1">Plafond</option>
                        </select>
                    </div>
                </div>
            </div>
        `;
        return html;
    }
    
    html(): string {
        return this.headerCoatings() + this.bodyCoatings();
    }
}